// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://api.goldenshrinejewels.com/",
});

export default axiosInstance;

// export const weburl = "https://manjit-jewellers-backend.onrender.com/";
export const weburl = "https://cloud.goldenshrinejewels.com/";
export const testurl = "https://api.goldenshrinejewels.com/";
export const ImageServer = "https://cloud.goldenshrinejewels.com/";

export const shopurl = "https://admin.goldenshrinejewels.com/";
export const mainurl = "https://app.goldenshrinejewels.com/";
export const fronturl = "https://app.goldenshrinejewels.com/";


export const keyLogin = process.env.REACT_APP_LOGIN_KEY;